export default __webpack_public_path__ + "static/media/algoColL2.77a6c8a9.svg";